import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAdmin } from '../hooks/useAdmin';

function Navbar() {
  const { user, logout } = useAuth();
  const { isAdmin } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [emailMenuOpen, setEmailMenuOpen] = useState(false);
  const [callsMenuOpen, setCallsMenuOpen] = useState(false);
  const [adminMenuOpen, setAdminMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-[#0a0e27]/80 backdrop-blur-md border-b border-blue-500/20 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo removed per requirements (no image logo) */}
          <Link 
            to="/" 
            className="flex items-center text-white font-semibold text-lg"
          >
            ConvrsAI
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${
                isActive('/') 
                  ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                  : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
              }`}
            >
              Home
            </Link>
            <Link
              to="/tasks"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${
                isActive('/tasks') 
                  ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                  : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
              }`}
            >
              Tasks
            </Link>
            
            <div 
              className="relative"
              onMouseEnter={() => setEmailMenuOpen(true)}
              onMouseLeave={() => setEmailMenuOpen(false)}
            >
              <button
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all flex items-center gap-1 ${
                  isActive('/email-accounts') || isActive('/campaigns') || isActive('/campaigns/create') || isActive('/dashboard')
                    ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                    : emailMenuOpen
                      ? 'text-blue-400 bg-blue-600/10'
                      : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                }`}
              >
                Email
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 12 12">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4.5l3 3 3-3" />
                </svg>
              </button>
              {emailMenuOpen && (
                <div className="absolute top-full left-0 pt-1 w-48 z-50">
                  <div className="bg-[#1a1f3a] border border-blue-500/30 rounded-lg shadow-xl py-1 backdrop-blur-md">
                    <Link
                      to="/dashboard"
                      className={`block px-4 py-2 text-sm transition-all ${
                        isActive('/dashboard') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                      }`}
                    >
                      Email Dashboard
                    </Link>
                    <Link
                      to="/email-accounts"
                      className={`block px-4 py-2 text-sm transition-all ${
                        isActive('/email-accounts') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                      }`}
                    >
                      Email Accounts
                    </Link>
                    <Link
                      to="/campaigns"
                      className={`block px-4 py-2 text-sm transition-all ${
                        isActive('/campaigns') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                      }`}
                    >
                      Campaigns
                    </Link>
                    <Link
                      to="/campaigns/create"
                      className={`block px-4 py-2 text-sm transition-all ${
                        isActive('/campaigns/create') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                      }`}
                    >
                      Create Campaign
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/scraper"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all ${
                isActive('/scraper') 
                  ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                  : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
              }`}
            >
              Scraper
            </Link>

            {/* <div 
              className="relative"
              onMouseEnter={() => setCallsMenuOpen(true)}
              onMouseLeave={() => setCallsMenuOpen(false)}
            >
              <button
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-all flex items-center gap-1 ${
                  isActive('/calls') || isActive('/calls/history')
                    ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                    : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                }`}
              >
                Calls
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 12 12">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4.5l3 3 3-3" />
                </svg>
              </button>
              {callsMenuOpen && (
                <div className="absolute top-full left-0 mt-1 w-40 bg-[#1a1f3a] border border-blue-500/30 rounded-lg shadow-xl py-1 z-50 backdrop-blur-md">
                  <Link
                    to="/calls"
                    className={`block px-4 py-2 text-sm transition-all ${
                      isActive('/calls') && !isActive('/calls/history') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                    }`}
                  >
                    Dispatch
                  </Link>
                  <Link
                    to="/calls/history"
                    className={`block px-4 py-2 text-sm transition-all ${
                      isActive('/calls/history') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                    }`}
                  >
                    History
                  </Link>
                </div>
              )}
            </div> */}

            {isAdmin && (
              <div 
                className="relative"
                onMouseEnter={() => setAdminMenuOpen(true)}
                onMouseLeave={() => setAdminMenuOpen(false)}
              >
                <button
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-all flex items-center gap-1 ${
                    isActive('/admin/users') || isActive('/tasks')
                      ? 'bg-blue-600/20 text-blue-400 border border-blue-500/30' 
                      : adminMenuOpen
                        ? 'text-blue-400 bg-blue-600/10'
                        : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                  }`}
                >
                  Admin
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 12 12">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4.5l3 3 3-3" />
                  </svg>
                </button>
                {adminMenuOpen && (
                  <div className="absolute top-full left-0 pt-1 w-48 z-50">
                    <div className="bg-[#1a1f3a] border border-blue-500/30 rounded-lg shadow-xl py-1 backdrop-blur-md">
                      <Link
                        to="/tasks"
                        className={`block px-4 py-2 text-sm transition-all ${
                          isActive('/tasks') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                        }`}
                      >
                        All Users Tasks
                      </Link>
                      <Link
                        to="/admin/users"
                        className={`block px-4 py-2 text-sm transition-all ${
                          isActive('/admin/users') ? 'bg-blue-600/20 text-blue-400' : 'text-gray-300 hover:text-blue-400 hover:bg-blue-600/10'
                        }`}
                      >
                        Users
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* User Section */}
          <div className="hidden md:flex items-center gap-4">
            <span className="text-sm text-gray-400">{user?.username || user?.email}</span>
            <button
              onClick={handleLogout}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-all shadow-lg shadow-blue-600/30"
            >
              Logout
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-300 hover:text-blue-400 p-2 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-blue-500/20 bg-[#0a0e27]/95 backdrop-blur-md">
          <div className="px-4 py-2 space-y-1">
            <Link to="/" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Home</Link>
            <Link to="/tasks" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Tasks</Link>
            <Link to="/dashboard" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Email Dashboard</Link>
            <Link to="/email-accounts" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Email Accounts</Link>
            <Link to="/campaigns" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Campaigns</Link>
            <Link to="/scraper" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Scraper</Link>
            <Link to="/calls" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Calls</Link>
            {isAdmin && <Link to="/admin/users" className="block px-4 py-2 text-sm text-gray-300 hover:text-blue-400 hover:bg-blue-600/10 rounded-lg transition-all">Admin</Link>}
            <button
              onClick={handleLogout}
              className="w-full text-left px-4 py-2 text-sm text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-all"
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
